import { useTranslation } from "react-i18next"
import secondsToHms from "utility/SecondToHms"


function OvertimeReportTable({ overtimes }) {

    const [t] = useTranslation(["global", "absenceReport"])

    function sortByDate(a, b) {
        return a.startDate - b.startDate
    }

    const orderedItems = [...overtimes]
    orderedItems.sort(sortByDate)

    let items = orderedItems.map((overtime, i) => {

        return (

            <section key={i}>
                <hr />
                <div className={`row ${overtimes.oth == 0 && "opacity-25"}`}>

                    <div className="col-sm">
                        {overtime.userDisplayName}
                    </div>

                    <div className="col-sm text-end">
                        <div>
                            <h5> STRAORDINARIO </h5>
                        </div>

                    </div>
                    <div className="col-sm">
                        <p>
                            <b>dal </b>{new Date(overtime.startDate * 1000).toLocaleDateString()}<br />
                            <b>al </b> {new Date(overtime.endDate * 1000).toLocaleDateString()}
                        </p>
                    </div>


                    <div className={`col-sm ${overtime.note ? '' : ''}`}>

                        <h4>{overtime.days}</h4>
                    </div>
                    <div className="col-sm">
                        <h4>{secondsToHms(overtime.hours)}</h4>
                    </div>
                    <div className="col-sm bg-success bg-opacity-25">
                        <h4> {(Math.round(overtime.oth * 100) / 100).toFixed(1)} h</h4>
                    </div>
                </div>



            </section>
        );
    })

    return (
        items.length > 0 ?
            <section>
                <div className="card bg-black bg-opacity-10 text-white mb-4">
                    <div className="card-header">
                        <i className="fa-solid fa-magnifying-glass"></i> {t("absenceReport:menu.details")}
                    </div>

                    <div className="card-body text-end">

                        <div className="row opacity-50">
                            <div className="col-sm">
                                {t("entity.employee")}
                            </div>
                            <div className="col-sm">
                                {t("absenceReport:property.reason")}
                            </div>
                            <div className="col-sm">
                                {t("property.period")}
                            </div>
                            <div className="col-sm">
                                <i className="fa-solid fa-calendar-days"></i> {t("property.days")}
                            </div>
                            <div className="col-sm">
                                <i className="fa-regular fa-clock"></i> {t("property.hours")}
                            </div>
                            <div className="col-sm">
                                <i className="fa-regular fa-clock"></i> WorkOff
                            </div>
                            <br />
                        </div>{items}
                    </div>

                </div>
            </section> : null


    )


}

export default OvertimeReportTable

